export default function PricePage() {
  return (
    <div className="prose max-w-none">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Գնացուցակ</h2>
      <p>
          Համապատասխանության հայտարարագրերի գրանցման արժեքները սահմանաված են ՀՀ էկոնոմիկայի նախարարի 2015թ. ապրիլի 16-ի թիվ 515 հրամանով (<a target={'_blank'} className={'text-blue-950'} href="https://arlis.am/hy/acts/97540">https://arlis.am/hy/acts/97540</a>), իսկ սերտիֆիկացման արժեքները սահմանված են ընկերության տնօրենի հրամանով, որը ըստ անհրաժեշտության մեր աշխատակիցները սիրով կտրամադրեն Ձեզ:
      </p>
    </div>
  );
}
